import { render, staticRenderFns } from "./draftCheckbox.vue?vue&type=template&id=bbd280c8&"
import script from "./draftCheckbox.vue?vue&type=script&lang=js&"
export * from "./draftCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports